<mat-accordion class="accordian-headers-align" multi>
  <mat-expansion-panel *ngFor="let item of reviewersList">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{item.reviewer}}
      </mat-panel-title>
      <mat-panel-description>
        Response Statistics
        <mat-icon>account_circle</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <app-graph [requestId]="requestId" [reviewerName]="item.reviewer"></app-graph>
    </ng-template>

  </mat-expansion-panel>
</mat-accordion>
